import { useState, useEffect } from 'react';
import { desktopBridge } from '../services/desktopBridge';

export interface DesktopConnectionState {
  isConnected: boolean;
  isChecking: boolean;
}

export function useDesktopConnection(): DesktopConnectionState {
  const [isConnected, setIsConnected] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    let mounted = true;

    const checkConnection = async () => {
      try {
        const available = await desktopBridge.isDesktopAvailable();
        if (mounted) {
          setIsConnected(available);
          setIsChecking(false);
          if (available) {
            console.log('🖥️ Desktop app connected');
          } else {
            console.log('⚠️ Desktop app not connected');
          }
        }
      } catch (error) {
        if (mounted) {
          setIsConnected(false);
          setIsChecking(false);
          console.log(
            '⚠️ Desktop app not connected (error checking connection)'
          );
        }
      }
    };

    // Initial check
    checkConnection();

    // Periodically check connection status
    const interval = setInterval(() => {
      if (mounted) {
        checkConnection();
      }
    }, 5000); // Check every 5 seconds

    return () => {
      mounted = false;
      clearInterval(interval);
    };
  }, []);

  return { isConnected, isChecking };
}
